/* Glam Touch — Lista de deseos (localStorage, sin necesidad de app externa) */
(function () {
  var KEY = 'gt_wishlist';

  function getAll() {
    try {
      var raw = window.localStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveAll(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function has(handle) {
    return getAll().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    var list = getAll();
    var idx = list.indexOf(handle);
    if (idx === -1) {
      list.push(handle);
    } else {
      list.splice(idx, 1);
    }
    saveAll(list);
    document.dispatchEvent(new CustomEvent('gt:wishlist:change', { detail: { list: list } }));
    return idx === -1;
  }

  function updateButtons() {
    var list = getAll();
    document.querySelectorAll('[data-gt-wishlist-toggle]').forEach(function (btn) {
      var active = list.indexOf(btn.dataset.gtWishlistToggle) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function updateCount() {
    var count = getAll().length;
    document.querySelectorAll('[data-gt-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function refresh() {
    updateButtons();
    updateCount();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-gt-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    toggle(btn.dataset.gtWishlistToggle);
    refresh();
  });

  document.addEventListener('gt:wishlist:change', refresh);
  document.addEventListener('DOMContentLoaded', refresh);
  refresh();

  window.gtWishlist = { getAll: getAll, has: has, toggle: toggle, refresh: refresh };
})();
